enum PlanLojinha {
  PLAN_BASICO = "plan-basico",
  PLANO_BASICO = "plano-basico",
}

export default PlanLojinha;
